import React from 'react';
import styled from 'styled-components';

const Padding = styled.div`
  margin: 20px 20px 0px 20px;
`;

export default ({ children }) => (

  <Padding className="padding-contentw">{children}</Padding>

)